import React, { useState, useEffect } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";
import CaseComponent from "../../components/CaseComponents/CaseComponent";
import Navbar from "../../components/ValuatorNavbar";
import { useSelectedCompany } from "../../contexts/SelectedCompanyContext";
import useFetchCompanyId from "../../hooks/CompanyHooks/useFetchCompanyId";
import useFetchCompanies from "../../hooks/useFetchCompanies";

function ArchivedCaseListPage() {
  const { selectedCompany, setSelectedCompany } = useSelectedCompany();
  const { companyId } = useFetchCompanyId(selectedCompany);
  const {companies, loading, error} = useFetchCompanies();
  const [archivedCases, setArchivedCases] = useState([]);
  useEffect(() => {
    const fetchArchivedCases = async () => {
      if (companyId) {
        const q = query(
          collection(db, "companies", companyId, "cases"),
          where("archived", "==", true)
        );
  
        const querySnapshot = await getDocs(q);
        const fetchedCases = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data()
        }));
  
        setArchivedCases(fetchedCases);
      } else {
        console.log("No company ID");
      }
    };
  
    fetchArchivedCases();
    
  }, [companyId]);
  
  return(
    <div>
        <Navbar/>
      <CaseComponent cases={archivedCases} isArchivedPage={true} selectedCompany={selectedCompany} companies={companies} setSelectedCompany={setSelectedCompany} />
    </div>
  );
}
export default ArchivedCaseListPage;
